<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">Provision booking #{{ data.bookingId }}</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  @if(detail){
  <div class="summary-row">
    <span class="summary-item"><b>{{ detail.familyCode || '-' }}</b></span>
    <span class="summary-item">{{ detail.requisitionCategory }} · {{ detail.requisitionType }} · {{ detail.requisitionMode }}</span>
    <span class="summary-item">{{ detail.requisitionFromDate }} → {{ detail.requisitionToDate }}</span>
    <span class="summary-item">{{ detail.requisitionGuestCount }} guest(s)</span>
    <span class="summary-item">{{ detail.requisitionStatus }} / {{ detail.requisitionLifecycleStatus }}</span>
  </div>
  }

  @if(guests.length){
  <div class="detail-block">
    <span class="block-title">Guests</span>
    <table class="detail-table">
      <thead><tr><th>Name</th><th>Type</th><th>Gender</th><th>Verified before</th></tr></thead>
      <tbody>
        @for(g of guests; track guestKey(g)){
        <tr>
          <td>{{ g.name || '-' }}</td>
          <td>{{ g.guestType }}</td>
          <td>{{ g.gender || '-' }}</td>
          <td>{{ g.isPhysicalVerified === true ? 'Yes' : g.isPhysicalVerified === false ? 'No' : '-' }}</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }

  @if(rooms.length){
  <div class="detail-block">
    <span class="block-title">Soft-allocated rooms</span>
    <table class="detail-table">
      <thead><tr><th>Guest house</th><th>Room</th><th>Type</th><th>Floor</th><th>Capacity</th></tr></thead>
      <tbody>
        @for(r of rooms; track roomKey(r)){
        <tr>
          <td>{{ r.guestHouseName }}</td>
          <td>{{ r.roomCode }}</td>
          <td>{{ r.accommoType }}</td>
          <td>{{ r.floorNumber }}</td>
          <td>{{ r.totalCapacity }}</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }

  @if(previousStays.length){
  <div class="detail-block">
    <span class="block-title">Previous stays (latest {{ previousStays.length }})</span>
    <table class="detail-table">
      <thead><tr><th>Booking</th><th>Dates</th><th>Type</th><th>Stage</th></tr></thead>
      <tbody>
        @for(s of previousStays; track stayKey(s)){
        <tr>
          <td>{{ s.requisitionId }}</td>
          <td>{{ s.requisitionFromDate }} → {{ s.requisitionToDate }}</td>
          <td>{{ s.requisitionCategory }} · {{ s.requisitionType }}</td>
          <td>{{ s.requisitionLifecycleStatus }}</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }

  <form [formGroup]="form" class="dialog-form">
    <div class="field-row">
      <div class="field">
        <span class="field-label">Category</span>
        <mat-form-field appearance="outline">
          <mat-select formControlName="category">
            @for(c of categories; track c){ <mat-option [value]="c">{{ c }}</mat-option> }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="field">
        <span class="field-label">Remark to caretaker</span>
        <select class="text-box-active" formControlName="caretakerChoice">
          <option value="">None</option>
          @for(r of caretakerRemarks; track r){ <option [value]="r">{{ r }}</option> }
          <option value="Other">Other…</option>
        </select>
      </div>
    </div>

    @if(form.value.caretakerChoice === 'Other'){
    <div class="field">
      <span class="field-label">Caretaker note</span>
      <textarea class="text-box-active" rows="2" formControlName="caretakerOther"></textarea>
    </div>
    }

    <div class="field">
      <span class="field-label">Provision remark</span>
      <textarea class="text-box-active" rows="2" formControlName="operatorProvisionRemark"></textarea>
    </div>
  </form>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Close</button>
    <button type="button" class="ac-primary-btn" (click)="submit()">Provision</button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
